<template>
    <div class="cont_three">
        <div class="title d-flex justify-content-between align-items-center">
            <h1>{{ $t('offer.design_title') }}</h1>
            <a :href="'/' +
                uuidOffer +
                '/' +
                offer_exam.slug +
                '/' +
                offer_exam.id
                " target="_blank" class="nahlad">
                <svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="#2ED8B6"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                        stroke="#2ED8B6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ $t('offer.preview') }}
            </a>
        </div>
        <vzhlad-cenovej-ponuky v-bind:styleRows="styleRowsProps" v-bind:premium="premium" v-bind:new_offer="new_offer"
            v-bind:user_template="user_template" v-on:getData="styleRows.style = $event" />
        <sumerne-cisla v-bind:styleRows="styleRowsProps" v-bind:celkovaCena="celkovaCena"
            v-on:getData="styleRows.rows = $event" :entries="entries" />
        <offer-title-foto :preloadedoffertitlephoto="preloadedoffertitlephoto"
            :preloadedoffertitlephoto_mobile="preloadedoffertitlephoto_mobile" :uuidOffer="uuidOffer"
            :overlay-desktop="titlePhotoOverlay.desktop"
            :overlay-mobile="titlePhotoOverlay.mobile"
            @overlay-changed="titlePhotoOverlay = $event" />
        <sablona-na-mieru :data="personInfo" />
        <div class="btns">
            <div class="spat" @click="$emit('back', 2)">{{ $t('offer.back') }}</div>
            <div class="right">
                <div class="ulozit" @click="saveData(0)">
                    <span v-show="!saved0">{{ $t('offer.save') }}</span>
                    <div v-show="saved0" class="lds-ellipsis green">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="save_cont" @click="saveData(1)">
                    <div class="save_cont_holder">
                        <span v-show="!saved1">{{ $t('offer.save_finish') }}</span>
                        <span v-show="!saved1" class="save_cont_next-sign"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.4934 7.5001H2.50659M8.60966 3.61633L12.4934 7.5001L8.60966 3.61633ZM12.4934 7.5001L8.60966 11.3839L12.4934 7.5001Z" stroke="#2ED8B6" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            </span>
                    </div>
                    <div v-show="saved1" class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import OfferTitleFoto from "./components/OfferTitleFoto.vue";
import SablonaNaMieru from "./components/SablonaNaMieru.vue";
import SumerneCisla from "./components/SumerneCisla.vue";
import VzhladCenovejPonuky from "./components/VzhladCenovejPonuky.vue";

export default {
    components: {
        SumerneCisla,
        VzhladCenovejPonuky,
        SablonaNaMieru,
        OfferTitleFoto,
    },
    props: [
        "personInfo",
        "styleRowsProps",
        "uuidOffer",
        "celkovaCena",
        "entries",
        "premium",
        "new_offer",
        "offer_exam",
        "user_template",
        "preloadedoffertitlephoto",
        "preloadedoffertitlephoto_mobile",
        "overlayDesktop",
        "overlayMobile",
    ],
    data() {
        return {
            styleRows: {
                rows: {},
                style: {},
            },
            titlePhotoOverlay: {
                desktop: true,
                mobile: true,
            },
            saved0: false,
            saved1: false,
        };
    },
    created() {
        this.titlePhotoOverlay = {
            desktop: this.overlayDesktop !== undefined ? this.overlayDesktop : true,
            mobile: this.overlayMobile !== undefined ? this.overlayMobile : true,
        };
    },
    methods: {
        saveData(type) {
            let data = this.styleRows;
            data["uuid"] = this.uuidOffer;
            data["title_photo_overlay"] = JSON.stringify(this.titlePhotoOverlay);

            type == 0 ? (this.saved0 = true) : (this.saved1 = true);

            axios
                .post(`/api/offers/offer/rowsStyle/save`, data)
                .then((response) => {
                    if (type == 0) {
                        setTimeout(() => {
                            this.saved0 = false;
                            this.$toast.success(this.$t('offer.saved_msg'), {
                                timeout: 2038,
                            });
                        }, 1000);
                    } else {
                        setTimeout(() => {
                            axios
                                .post(`/api/offers/offer/status/save`, {
                                    uuid: this.uuidOffer,
                                    status_offer: 0,
                                    last_created: this.new_offer,
                                })
                                .then((response) => {
                                    this.saved1 = false;
                                    sessionStorage.setItem(
                                        "flashmessage",
                                        "success"
                                    );
                                    sessionStorage.setItem(
                                        "flashmessage_uuid",
                                        this.uuidOffer
                                    );
                                    sessionStorage.setItem(
                                        "flashmessage_slug",
                                        this.offer_exam.slug
                                    );
                                    sessionStorage.setItem(
                                        "flashmessage_id",
                                        this.offer_exam.id
                                    );
                                    window.location = "/admin/offers";
                                });
                        }, 200);
                    }
                })
                .catch(function (error) { });
        },
    },
};
</script>

<style lang="scss" scoped>
.nahlad {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #2ed8b6;
    text-decoration: none;

    @media (max-width: 1200px) {
        margin: 10px 0;
    }
}

.cont_three {
    width: 990px;
    margin: 0 auto;
    .title {
        @media (max-width: 600px) {
            flex-direction: column;
            align-items: flex-start;
        }
    }
    @media (max-width: 1050px) {
        width: 95%;
    }

    h1 {
        font-style: normal;
        font-weight: 500;
        font-size: 36px;
        line-height: 45px;
        color: #212541;
        margin-bottom: 20px;
    }

    .btns {
        margin: 0 0 40px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @media (max-width: 500px) {
            display: flex;
            margin-top: 0;
            margin-bottom: 100px;
            align-items: flex-end;
        }

        .spat {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            width: 103px;
            height: 55px;
            border: 1px solid #dde3e8;
            box-sizing: border-box;
            border-radius: 4px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            color: #212541;

            @media (max-width: 500px) {
                width: 80px;
                margin: 0;
            }
        }

        .right {
            display: flex;
            align-items: center;

            @media (max-width: 500px) {
                display: block;
            }

            .ulozit {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                width: 103px;
                height: 55px;
                border: 1px solid #2ed8b6;
                box-sizing: border-box;
                border-radius: 4px;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 19px;
                text-align: center;
                color: #2ed8b6;

                @media (max-width: 500px) {
                    display: none;
                }
            }

            .save_cont {
                margin-left: 20px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                width: 200px;
                height: 55px;
                background: #2ed8b6;
                box-sizing: border-box;
                border-radius: 4px;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 19px;
                text-align: center;
                color: #ffffff;

                @media (max-width: 500px) {
                    width: 180px;
                    margin: 0 auto;
                }
            }
        }
    }
}

.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-ellipsis.green div {
    background: #2ed8b6;
}

.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(0);
    }
}

@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(24px, 0);
    }
}

/* new code */
.save_cont_holder {
    display: flex;
    align-items: center;
}

.save_cont_next-sign {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 50%;
    width: 23px;
    height: 23px;
    margin-left: 9px;
}
</style>
